// Utility for driver duty overlap detection

import { ShiftBatRowType } from "../model/ShiftBatRowType";

/**
 * Detects overlapping rows in a shiftbat (ignoring notes, stops, etc)
 * @param {Array} rows
 * @returns {{filteredRows: Array, overlappingRowIds: Set}}
 */
export function detectDutyOverlaps(rows) {
    // Filter to only include types we want to display
    const filteredRows = rows.filter(row => [
        ShiftBatRowType.noteTimed, 
        ShiftBatRowType.location, 
        ShiftBatRowType.stop, 
        ShiftBatRowType.stopNote, 
        ShiftBatRowType.template
    ].includes(row.type));
    // Sort rows by start time
    // const sortedRows = [...filteredRows].sort((a, b) => {
    //     const aTime = a.getTime?.() || 0;
    //     const bTime = b.getTime?.() || 0;
    //     return aTime - bTime;
    // });
    // Mark overlapping rows
    const overlappingRowIds = new Set();
    for (let i = 0; i < filteredRows.length; i++) {
        const currentRow = filteredRows[i];
        const currentStartTime = currentRow.getTime?.() || 0;
        const currentEndTime = currentRow.getEndTime?.() || 0;
        for (let j = i + 1; j < filteredRows.length; j++) {
            const nextRow = filteredRows[j];
            const nextStartTime = nextRow.getTime?.() || 0;
            const nextEndTime = nextRow.getEndTime?.() || 0;
            if (nextStartTime < currentEndTime) {
                overlappingRowIds.add(currentRow.id);
                overlappingRowIds.add(nextRow.id);
            }
        }
    }
    return {
        filteredRows: rows,
        overlappingRowIds
    };
} 